import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import link from './link.js';
import requiredImage from '../fragments/requiredImage.js';
var schema = defineObject('reportsGridSectionReport', {
    image: {
        title: 'Image',
        type: 'image',
        options: requiredImage.fragment.options
    },
    title: {
        title: 'Title',
        type: 'string'
    },
    description: {
        title: 'Description',
        type: 'text'
    },
    datetime: {
        title: 'Datetime',
        type: 'datetime'
    },
    action: {
        title: 'Action',
        type: 'link'
    }
}, [
    link.schema.link
]);
var validator = z.object({
    _type: z.literal('reportsGridSectionReport'),
    image: requiredImage.validator.optional(),
    title: z.string().optional(),
    description: z.string().optional(),
    datetime: z.string().optional(),
    action: link.validator.optional()
});
schema.reportsGridSectionReport;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=reportsGridSectionReport.js.map